import styled from 'styled-components';
import { colors, fonts, mixins } from '../../css';

// eslint-disable-next-line
export const StyledCardTag = styled.div`
  background-color: ${props => props.color};
  color: ${colors.colorWhite};
  display: inline;
  padding: ${mixins.pxToRem(12)} ${mixins.pxToRem(30)};
  text-transform: uppercase;
  font-size: ${mixins.pxToRem(12)};
  font-family: ${fonts.fontBold};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
